/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 16:51:41
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-07 08:51:37
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentCollapseHeader/index.tsx
 */

import { InfoCircleFilled } from '@ant-design/icons';
import { useClickAway } from 'ahooks';
import { Menu, Tooltip } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import LeftGreenBlock from 'src/components/DragContainers/LeftGreenBlock';

import { DropDown, Input } from '@/src/components/Antd';
import { ICON_PREFIX } from '@/src/tools/constant';
import { Icon } from '@/src/tools/icon';
import { ActionType } from '@/src/types/common/common';
import { EnumModuleType } from '@/src/types/common/module';
import { onContentErrorHooks } from 'src/constrains/DraggableModules/tools';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './css.less';
const ContentCollapseHeader = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDelete,
    draggableId,
    getContent,
    moduleType,
    onStaticChange,
    getErrorDisplay,
    open,
    extraProps,
    disabled,
    onDuplicate,
    onReset,
  } = props;
  //console.log('onDuplicate', onDuplicate);
  const isOpen = open;

  const ref = React.useRef();

  const _err: any = useSelector(getErrorDisplay(draggableId));
  const { display } = _err;

  const context: any = useSelector(getContent(draggableId));
  const visible = _.get(context, 'staticData.visible', true);
  const name = _.get(context, 'staticData.moduleName', '');
  const [dropVisible, setDropVisible] = React.useState(false);
  const [inputVisible, setInputVisible] = React.useState(false);
  const [value, setValue] = React.useState(name);

  const {
    currentHasPreviousError: hasError, //->对应现在应该显示HasError,对应pDataError里面的数据
  } = onContentErrorHooks({
    data: context,
    isOpen,
    display,
    validationProps: extraProps,
  });

  useClickAway(() => {
    handlePressEnter();
  }, ref);

  const showInput = (e: React.MouseEvent) => {
    e.stopPropagation();
    setInputVisible(true);
  };

  const handleValueChange = (value) => setValue(value);

  const handleOnCollapseDelete = (e: React.MouseEvent) => {
    if (onDelete) {
      onDelete(draggableId);
    }
  };
  const handleSetVisibility = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDropVisible(false);
    const { staticData } = context;
    onStaticChange({
      type: ActionType.modify,
      id: draggableId,
      data: { ...staticData, visible: !visible },
    });
  };

  const handlePressEnter = () => {
    if (value) {
      setInputVisible(false);
      const { staticData } = context;
      onStaticChange({
        type: ActionType.modify,
        id: draggableId,
        data: { ...staticData, moduleName: value },
      });
    }
  };

  const handleStopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const renderIcon = () => {
    switch (moduleType) {
      case EnumModuleType.Carousel:
        return `${ICON_PREFIX}icon_carousel.svg`;
      case EnumModuleType.ProductCarousel:
        return `${ICON_PREFIX}icon_carousel.svg`;
      case EnumModuleType.Poster:
        return `${ICON_PREFIX}icon_posters.svg`;
      case EnumModuleType.LongCanvas:
        return `${ICON_PREFIX}icon_long-canvas.svg`;
      case EnumModuleType.Text:
        return `${ICON_PREFIX}icon_text.svg`;
      case EnumModuleType.ProductGrid:
        return `${ICON_PREFIX}icon_grid.svg`;
      case EnumModuleType.ProductList:
        return `${ICON_PREFIX}icon_list.svg`;
      case EnumModuleType.Subscription:
        return `${ICON_PREFIX}icon_list.svg`;
      case EnumModuleType.ArticleCarousel:
        return `${ICON_PREFIX}icon_list.svg`;
      case EnumModuleType.ArticleList:
        return `${ICON_PREFIX}icon_list.svg`;
    }
  };

  const isResponsive = [
    EnumModuleType.ResponsiveProductCarousel,
    EnumModuleType.ResponsiveImageCarousel,
    EnumModuleType.ResponsiveContentCarousel,
    EnumModuleType.ResponsiveSubscription,
    EnumModuleType.ResponsiveText,
    EnumModuleType.ResponsivePoster,
    EnumModuleType.ResponsiveProductGrid,
    EnumModuleType.ResponsiveContentGrid,
    EnumModuleType.ResponsiveProductTab,
    EnumModuleType.ResponsiveContentTab,
    EnumModuleType.ResponsivePosterTab,
  ].includes(moduleType);

  const renderMenu = () => {
    return (
      <div className='override'>
        <Menu selectedKeys={[]}>
          {/* <Menu.Item
            key='visibleOnChange'
            onClick={({ item, key, keyPath, domEvent }) => {}}>
            <div>move up</div>
          </Menu.Item>
          <Menu.Item
            key='visibleOnChange'
            onClick={({ item, key, keyPath, domEvent }) => {}}>
            <div>movedown</div>
          </Menu.Item> */}
          <Menu.Item
            key='visibleOnChange'
            onClick={({ item, key, keyPath, domEvent }) => {
              handleSetVisibility(domEvent);
            }}>
            <div>
              {visible
                ? getI18n('general.setasInvisible')
                : getI18n('general.setasVisible')}
            </div>
          </Menu.Item>
          <Menu.Item
            key='duplicate'
            onClick={({ item, key, keyPath, domEvent }) => {
              // handleSetVisibility(domEvent);
            }}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (onDuplicate) {
                  onDuplicate(draggableId);
                } //console.log('draggableId2', draggableId);
                setDropVisible(false);
              }}>
              {getI18n('general.duplicated')}
            </div>
          </Menu.Item>
          {isResponsive && !disabled ? (
            <React.Fragment>
              <Menu.Item key='reset'>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (onReset) {
                      onReset(draggableId);
                    }
                    setDropVisible(false);
                  }}>
                  {getI18n('general.resetStyle')}
                </div>
              </Menu.Item>
            </React.Fragment>
          ) : null}
          {disabled ? null : (
            <Menu.Item key='visibleOnDelete'>
              <WarningPopReminder
                title={getI18n('general.deleteModule')}
                content={getI18n('general.deleteModuleContent')}
                onOk={handleOnCollapseDelete}>
                <div
                  onClick={(e) => {
                    setDropVisible(false);
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                  style={{ color: '#FF695F' }}>
                  {getI18n('general.delete')}
                </div>
              </WarningPopReminder>
            </Menu.Item>
          )}
        </Menu>
      </div>
    );
  };

  return (
    <LeftGreenBlock hide={disabled}>
      <div
        // onClick={() => {
        //   const ele = document.getElementById('hallo');
        //   console.log(ele);
        //   ele.focus();
        // }}
        className={styles.container}
        style={{ backgroundColor: !visible && '#FAFAFC' }}>
        <div className={styles.left}>
          {/* <div className={styles.greenBlock} /> */}
          {/* <button onClick={handleOnCollapseDelete}>_d</button> */}
          <img src={renderIcon()} alt='' className={styles.image} />
          <span className={styles.visible} onClick={handleSetVisibility}>
            <img
              src={
                visible
                  ? `${ICON_PREFIX}icon_visible.svg`
                  : `${ICON_PREFIX}icon_invisible.svg`
              }
            />
          </span>
          {/* {!disabled && (
            <span className={styles.visible} onClick={handleSetVisibility}>
              <img
                src={
                  visible
                    ? `${ICON_PREFIX}icon_visible.svg`
                    : `${ICON_PREFIX}icon_invisible.svg`
                }
              />
            </span>
          )} */}

          {inputVisible && !disabled ? (
            <span className={styles.name} ref={ref}>
              <Input
                maxLength={50}
                value={value}
                onClick={handleStopPropagation}
                onChange={handleValueChange}
                onPressEnter={handlePressEnter}
                autoFocus
              />
            </span>
          ) : (
            <Tooltip title={name}>
              <span className={styles.name} onClick={showInput}>
                {name}
              </span>
            </Tooltip>
          )}
        </div>
        <div className={styles.right}>
          {display && hasError && (
            <InfoCircleFilled rev className={styles.iconWarn} />
          )}
          {!disabled && (
            <div className={styles.dropdown}>
              <DropDown
                overlay={renderMenu()}
                trigger={['click']}
                visible={dropVisible}
                onVisibleChange={setDropVisible}>
                <Icon
                  type='iconMore'
                  className={styles.more}
                  onClick={(e) => e.stopPropagation()}
                />
              </DropDown>
            </div>
          )}
        </div>
      </div>
    </LeftGreenBlock>
  );
};
export default ContentCollapseHeader;
